import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/AntdRegistry.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["InventoryNavProvider"] */ "/app/app/inventory/components/InventoryNavContext.tsx");
